import { render, staticRenderFns } from "./BankPicketItem.vue?vue&type=template&id=62598e28&"
import script from "./BankPicketItem.vue?vue&type=script&lang=js&"
export * from "./BankPicketItem.vue?vue&type=script&lang=js&"
import style0 from "./BankPicketItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports